import { ProductSummaryMetadata } from 'components/common-form/sidePanel/docToolbar/summary/builder/model';
import type { QuoteFormError } from 'state/addonForm/addonForm.selector';
import type { QuoteState } from 'state/quotes/infos/infos.model';

export const execOnlyActionNames = ['ExecOnly', 'AdvancedExecOnly'] as const;
export const tradableActionNames = ['TradableQuote', 'AdvancedTradableQuote'] as const;
export const executableActionNames = ['ExecutableQuote', 'AdvancedExecutableQuote'] as const;
export const bookableActionNames = ['BookWithoutExecution', 'BookWithExecution'] as const;

export const primaryActionNames = [
  ...tradableActionNames,
  ...executableActionNames,
  ...execOnlyActionNames,
  ...bookableActionNames,
  'IndicativeQuote',
  'AdvancedIndicativeQuote',
  'AddonQuote',
] as const;

const actionNames = [...primaryActionNames, 'AddonQuoteExecutionOnly', 'ScheduleRun'] as const;
export type ActionName = (typeof actionNames)[number];
export type BookingActionName = Extract<ActionName, 'BookWithExecution' | 'BookWithoutExecution'>;
export type QuoteActionName = Exclude<ActionName, 'AddonQuote' | 'AddonQuoteExecutionOnly'>;

export type PriceEnhancerMode = 'None' | 'UpfrontFee' | 'Reoffer' | 'Premium';

export type QuoteAction<Name = QuoteActionName> = Readonly<{
  isDisabled?: boolean;
  name: Name;
  priceEnhancement?: PriceEnhancerMode;
  tooltipKey?: string;
}>;

export interface EnrichmentError {
  correlationId: string;
  traceId: string;
}

export type FormInfos = Readonly<{
  actions: readonly QuoteAction[];

  enrichmentError?: EnrichmentError | Error;

  negotiationId?: string;

  quoteId?: string;

  quoteState?: QuoteState;
  quoteQuery: unknown;

  summary?: { opened: boolean; payload?: ProductSummaryMetadata };
  validationErrors?: readonly QuoteFormError[];
  version: number;
  formActiveTab?: string;
  crossBrowserDirty?: boolean;
  sendWholeFormData?: boolean;
}>;
